module.exports = "/images/contract.svg?3bcf1791682376f4b8e0cc513cc7b602";